// ===== The core kit: parts, machines, goals and skins, registered with the same API as the worlds =====
// One file per part/object/goal with geometry, physics, drawing, icon, intro and blocking together.
// The order here is the registration order (system hooks run in that order, e.g. toaster before pulley).
// Imported before the worlds (src/worlds/index.ts). Typed keys: keys.ts (npm run keys).
import { Registry } from '../core/registry';
import { plank, long_plank } from './plank';
import { pad } from './pad';
import { box } from './box';
import { paint } from './paint';
import { seesaw } from './seesaw';
import { stone } from './stone';
import { banana } from './banana';
import { toaster } from './toaster';
import { button } from './button';
import { rope } from './rope';
import { pulley } from './pulley';
import { duck } from './duck';
import { bowl } from './bowl';
import { bell } from './bell';
import { skins } from './skins';

Registry.kit({
  parts: { plank, long_plank, pad, box, paint, seesaw, stone, banana },
  objs: { toaster, button, rope, pulley, duck },
  goals: { bowl, bell },
  skins,
});

export { TAG_ICONS, drawTitleParts, drawGoalIcon } from './showcase';
